  import { Injectable } from '@angular/core';
  import { FormGroup } from '@angular/forms';
  import { ExecutionQueue } from './execution-queue';
  import { TransactionContext } from './transaction-context';

  @Injectable({ providedIn: 'root' })
  export class TransactionEngine {

    constructor(
      private queue: ExecutionQueue,
      private ctx: TransactionContext
    ) {}

    attach(
      form: FormGroup,
      handlers: {
        dataFlow: (f: string)=>void,
        compute: (f:string)=>void
      }
    ) {

      Object.keys(form.controls).forEach(field => {

        form.get(field)?.valueChanges.subscribe(() => {

          this.queue.enqueue(field);

          this.queue.flush((changed) => {

            handlers.dataFlow(
              changed
            );

            handlers.compute(
              changed
            );

          });

        });

      });

    }
  }